import { Component, Input } from '@angular/core';
import { ResourceTag } from '@app/app/shared/models';

@Component({
  selector: 'ptl-v3-folio-masonry-card-tags',
  templateUrl: './v3-folio-masonry-card-tags.component.html',
  styleUrls: ['./v3-folio-masonry-card-tags.component.scss'],
})
export class V3FolioMasonryCardTagsComponent {
  @Input() tags: ResourceTag[] = [];

  showAllTags = false;
  readonly maxVisibleTags = 2;

  get visibleTags(): ResourceTag[] {
    if (this.showAllTags || this.tags.length <= this.maxVisibleTags) {
      return this.tags;
    }
    return this.tags.slice(0, this.maxVisibleTags);
  }

  get hasMoreTags(): boolean {
    return this.tags.length > this.maxVisibleTags;
  }

  get hiddenTagsCount(): number {
    return Math.max(0, this.tags.length - this.maxVisibleTags);
  }

  onShowMoreClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.showAllTags = true;
  }
}
